<template>
  <div id="pace-efficiency-containier" class="border-padding">
  <main>
    <div class="row">
      <div class="col-md-2"  v-if="season_dropdown.data != undefined">
        <label class="typo__label">Season</label>
        <multiselect
          v-model="season_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          placeholder=""
          :options="season_dropdown.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>

      <div class="col-md-2">
      <label class="typo__label">Season Type</label>
      <multiselect
        v-model="season_type_selected"
        select-label=""
        deselect-label=""
        track-by="id"
        label="text"
        :preselect-first="true"
        :options="season_type_options"
        :searchable="false"
        :show-labels="false"
        :allow-empty="false">
        <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
      </multiselect>
      </div>

      <div class="col-md-2">
        <label class="typo__label">Type</label>
        <multiselect
          v-model="type_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          placeholder=""
          :options="type_dropdown"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>
    </div>

    <div class="border-padding">
      <button class="" v-on:click="changeStats()">Get Stats</button>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <div v-if="table_data.length > 0">
        <vue-good-table
            :columns="table_columns"
            :rows="table_data"
            :pagination-options="{ enabled: true, perPage: 30}"
            :searchOptions="{ enabled: false}"
            :sort-options="{ enabled: true, initialSortBy: {field: 'team_name', type: 'asc'}}"
            styleClass="vgt-table bordered striped">
            <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field != 'team_name'">
                <span>
                  {{props.formattedRow[props.column.field]}} ({{props.row[props.column.field + '_rank']}})
                </span>
              </div>
              <div v-else>
                <span>
                  <b>{{props.formattedRow[props.column.field]}}</b>
                </span>
              </div>
            </template>
            <template slot="table-column" slot-scope="props">
            <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
                {{props.column.label}}
            </span>
            <span v-else>
                {{props.column.label}}
            </span>
            </template>
        </vue-good-table>
    </div>
  </main>
  </div>
</template>

<script>
import axios from 'axios'
import GetDropdownOptions from './mixins/get_dropdown'
import Multiselect from 'vue-multiselect'
import { rateStats } from './mixins/rate_stats'
import { tableUtils } from './mixins/table_utils'
import { season } from './mixins/dropdowns'

export default {
  name: 'PaceEfficiencySummary',
  components: {
    Multiselect
  },
  mixins: [rateStats, tableUtils, GetDropdownOptions, season],
  data () {
    return {
      loading: false,
      season_dropdown: {},
      season_selected: undefined,
      season_type_selected: undefined,
      season_type_options: [
        {'id': 'Regular+Season', 'text': 'Regular Season'},
        {'id': 'Playoffs', 'text': 'Playoffs'}
      ],
      type_dropdown: [
        {'id': 'Team', 'text': 'Team'},
        {'id': 'Opponent', 'text': 'Opponent'}
      ],
      type_selected: undefined,
      table_data: [],
      table_columns: [
        {'field': 'team_name', 'label': 'Team'},
        {'field': 'ppp', 'label': 'PPP', 'type': 'decimal', 'tooltip': 'Points Per Possession'},
        {'field': 'spp', 'label': 'Pace', 'type': 'decimal', 'tooltip': 'Seconds Per Possession'},
        {'field': 'ppp_off_missed_fg', 'label': 'PPP Off Missed FG', 'type': 'decimal', 'tooltip': 'Points Per Possession Off Missed FG'},
        {'field': 'spp_off_missed_fg', 'label': 'Pace Off Missed FG', 'type': 'decimal', 'tooltip': 'Seconds Per Possession Off Missed FG'},
        {'field': 'ppp_off_made_fg', 'label': 'PPP Off Made FG', 'type': 'decimal', 'tooltip': 'Points Per Possession Off Made FG'},
        {'field': 'spp_off_made_fg', 'label': 'Pace Off Made FG', 'type': 'decimal', 'tooltip': 'Seconds Per Possession Off Made FG'},
        {'field': 'ppp_off_rim_miss', 'label': 'PPP Off At Rim Miss', 'type': 'decimal', 'tooltip': 'Points Per Possession Off At Rim Miss'},
        {'field': 'spp_off_rim_miss', 'label': 'Pace Off At Rim Miss', 'type': 'decimal', 'tooltip': 'Seconds Per Possession Off At Rim Miss'},
        {'field': 'team_name', 'label': 'Team'},
        {'field': 'ppp_off_midrange_miss', 'label': 'PPP Off Mid-Range Miss', 'type': 'decimal', 'tooltip': 'Points Per Possession Off Mid-Range Miss'},
        {'field': 'spp_off_midrange_miss', 'label': 'Pace Off Mid-Range Miss', 'type': 'decimal', 'tooltip': 'Seconds Per Possession Off Mid-Range Miss'},
        {'field': 'ppp_off_missed3', 'label': 'PPP Off Missed 3', 'type': 'decimal', 'tooltip': 'Points Per Possession Off Missed 3'},
        {'field': 'spp_off_missed3', 'label': 'Pace Off Missed 3', 'type': 'decimal', 'tooltip': 'Seconds Per Possession Off Missed 3'},
        {'field': 'ppp_off_missed_ft', 'label': 'PPP Off Missed FT', 'type': 'decimal', 'tooltip': 'Points Per Possession Off Missed FT'},
        {'field': 'spp_off_missed_ft', 'label': 'Pace Off Missed FT', 'type': 'decimal', 'tooltip': 'Seconds Per Possession Off Missed FT'},
        {'field': 'ppp_off_made_ft', 'label': 'PPP Off Made FT', 'type': 'decimal', 'tooltip': 'Points Per Possession Off Made FT'},
        {'field': 'spp_off_made_ft', 'label': 'Pace Off Made FT', 'type': 'decimal', 'tooltip': 'Seconds Per Possession Off Made FT'},
        {'field': 'team_name', 'label': 'Team'},
        {'field': 'ppp_off_deadball', 'label': 'PPP Off Dead Ball', 'type': 'decimal', 'tooltip': 'Points Per Possession Off Dead Ball'},
        {'field': 'spp_off_deadball', 'label': 'Pace Off Dead Ball', 'type': 'decimal', 'tooltip': 'Seconds Per Possession Off Dead Ball'},
        {'field': 'ppp_off_timeout', 'label': 'PPP Off Timeout', 'type': 'decimal', 'tooltip': 'Points Per Possession Off Timeout'},
        {'field': 'spp_off_timeout', 'label': 'Pace Off Timeout', 'type': 'decimal', 'tooltip': 'Seconds Per Possession Off Timeout'},
        {'field': 'ppp_off_steal', 'label': 'PPP Off Steal', 'type': 'decimal', 'tooltip': 'Points Per Possession Off Steal'},
        {'field': 'spp_off_steal', 'label': 'Pace Off Steal', 'type': 'decimal', 'tooltip': 'Seconds Per Possession Off Steal'}
      ],
      show_error_message: false,
      api_endpoint: 'get-pace-efficiency-summary/'
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData',
    '$parent.league': 'changeLeague'
  },
  methods: {
    changeLeague () {
      this.season_dropdown = {}
      this.season_selected = undefined
      this.type_selected = undefined
      this.season_type_selected = undefined
      this.table_data = []
      this.$router.push({name: 'pace_efficiency_summary', params: {league: this.$parent.league}})
    },
    setTypeDropdown (response) {
      if (!this.type_selected) {
        this.type_selected = this.type_dropdown[0]
      }

      if (this.$route.query.Type) {
        this.type_dropdown.forEach((type) => {
          if (type.id === this.$route.query.Type) {
            this.type_selected = type
          }
        })
      }
    },
    setSeasonDropdown () {
      this.season_dropdown = this.getSeasonDropdownForLeague(this.$route.params.league)
      if (this.$route.query.Season) {
        this.season_dropdown.data.forEach((season) => {
          if (season.id === this.$route.query.Season) {
            this.season_selected = season
          }
        })
      }

      // this happens on league change  - set to first option
      if (this.season_selected.length === 0) {
        this.season_selected.push(this.season_dropdown.data[0])
      }
    },
    setSeasonTypeDropdown () {
      if (!this.season_type_selected) {
        this.season_type_selected = this.season_type_options[0]
      }
      this.season_type_options.forEach((seasonType) => {
        if (seasonType.id === this.$route.query.SeasonType) {
          this.season_type_selected = seasonType
        }
      })
    },
    checkIfStatsShouldBeLoaded () {
      if (this.$route.query.Season && this.$route.query.SeasonType) {
        this.getStats()
      }
    },
    loadData () {
      this.getDropdown([this.setSeasonDropdown, this.setSeasonTypeDropdown, this.setTypeDropdown, this.checkIfStatsShouldBeLoaded], {})
    },
    updateData () {
      this.table_data = []

      if (this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.Type) {
        this.getStats()
      } else {
        this.loadData()
      }
    },
    changeStats () {
      var params = {}
      params[this.$seasonParam] = this.season_selected.id
      params[this.$seasonTypeParam] = this.season_type_selected.id
      params[this.$typeParam] = this.type_selected.id

      this.$router.push({name: 'pace_efficiency_summary', query: params})
    },
    getStats () {
      this.show_error_message = false
      this.table_data = []
      var params = this.$route.query

      if (params.Season && params.SeasonType && params.Type) {
        this.loading = true
        axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
          params: params
        })
          .then((response) => {
            if (!response.data.error) {
              this.table_data = response.data.results
            } else {
              this.show_error_message = true
            }
            this.loading = false
          }, (error) => {
            this.show_error_message = true
            this.loading = false
            this.error = error
          })
      }
    }
  }
}
</script>

<style scoped>
@import "https://maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css"

</style>



// WEBPACK FOOTER //
// src/components/PaceEfficiencySummary.vue